<template>
    <section
        class="section-padding bg-light-gray px-3"
        id="program-lojalnosti-sa-popustom"
    >
        <div class="max-w-md mx-auto">
            <h2 class="text-center mb-5">
                Program lojalnosti sa dinarskim popustom
            </h2>
            <p class="text-left text-md-center pb-3">
                Program funkcioniše kao dosadašnja Euro Petrol kartica i
                aplikacija za fizička lica.<br />
                Ostvaruješ uštedu po litru pri svakom tankovanju, popuste na
                dodatne usluge i proizvode, kao i 10% popusta na kompletan Lion
                Expert asortiman.
            </p>
        </div>
        <div class="py-5">
            <div class="border rounded-3 overflow-hidden max-w-lg mx-auto">
                <table
                    class="d-none d-md-table table table-discounts table-borderless mb-0"
                >
                    <thead class="table-light">
                        <tr>
                            <th class="bg-gray col-3">Gorivo usluge i shop</th>
                            <th
                                class="bg-color-main text-center text-light col-3"
                            >
                                Popust
                            </th>
                            <th class="bg-gray col-3">Gorivo usluge i shop</th>
                            <th
                                class="bg-color-main text-center text-light col-3"
                            >
                                Popust
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="index in dataRows.length / 2" :key="index">
                            <td>{{ dataRows[index - 1].propertyName }}</td>
                            <td class="text-center">
                                {{ dataRows[index - 1].discount }}
                            </td>
                            <td>
                                {{
                                    dataRows[index + dataRows.length / 2 - 1]
                                        .propertyName
                                }}
                            </td>
                            <td class="text-center">
                                {{
                                    dataRows[index + dataRows.length / 2 - 1]
                                        .discount
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table
                    class="d-table d-md-none table table-discounts table-borderless mb-0"
                >
                    <thead class="table-light">
                        <tr>
                            <th class="bg-gray col-3">Gorivo usluge i shop</th>
                            <th
                                class="bg-color-main text-center text-light col-3"
                            >
                                Popust
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in dataRows" :key="row.propertyName">
                            <td>{{ row.propertyName }}</td>
                            <td class="text-center">
                                {{ row.discount }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="px-2 py-5">
            <div class="bordered-box mx-auto text-center max-w-lg py-3 py-lg-4">
                <div class="d-flex flex-column align-items-center gap-2 mb-3">
                    <img
                        class="text-dark"
                        src="/img/application/vector/star.svg"
                    />
                    <strong class="subtitle">Primer</strong>
                </div>
                <p>
                    Korisnik je natočio 12 litara Lion Expert BMB 100 goriva
                    čija je cena 219,90 rsd/litri. Na kasi račun iznosi 2.578,80
                    RSD. Korisnik programa lojalnosti prilikom plaćanja
                    prikazuje svoj personalizovani QR ili Bar kod iz aplikacije
                    kako bi ga kasir skenirao. Na kupovinu Expert 100 litara
                    korisnik ostvaruje pravo na popust od 5 rsd/litri.
                    Dakle,umesto 2.578,8 RSD, korisnik će platiti račun 2.518,80
                    RSD.<br />
                    Ukoliko je korisnik kupio Lion Expert ulje u vrednosti od
                    750,00 RSD, ostvaruje pravo na 10 % popusta jer je ulje deo
                    Lion Expert asortimana. U ovom primeru korisnik će ulje
                    platiti 675,00 RSD.
                </p>
            </div>
        </div>
    </section>
</template>

<script setup>
const dataRows = [
    { propertyName: "Evro dizel", discount: "2 rsd/l" },
    { propertyName: "Evro Premijum BMB 95", discount: "2 rsd/l" },
    { propertyName: "Autogas TNG", discount: "2 rsd/l" },
    { propertyName: "Lion Expert Dizel", discount: "10 rsd/l" },
    { propertyName: "Lion Expert BMB 100", discount: "10 rsd/l" },
    { propertyName: "AdBlue", discount: "10 rsd/l" },
    { propertyName: "PB 5/1 punjenje", discount: "25 rsd/kom" },
    { propertyName: "PB 10/1 punjenje", discount: "50 rsd/kom" },
    { propertyName: "PB 35/1 punjenje", discount: "175 rsd/kom" },
    { propertyName: "Usisavanje", discount: "20 rsd" },
    { propertyName: "Ručno pranje", discount: "20 rsd" },
    { propertyName: "Mašinsko pranje", discount: "50 rsd" },
    { propertyName: "Barcaffe kafa", discount: "-15%" },
    { propertyName: "Lion Expert asortiman", discount: "-10%" },
];
</script>

<style scoped>
.bg-gray {
    background-color: #eaeaea;
}

.table-discounts td,
.table-discounts th {
    vertical-align: middle;
}

.table-discounts th {
    padding: 1rem 1.5rem !important;
}

.table-discounts td {
    padding: 0.875rem 1.5rem;
}

.table-discounts tfoot {
    font-size: 0.875rem;
}

@media (max-width: 1280px) {
    .table-discounts th {
        padding: 1.125rem 1.5rem !important;
    }

    .table-discounts td {
        padding: 0.625rem 1.5rem !important;
    }

    .table-discounts td,
    .table-discounts th {
        font-size: 0.875rem;
    }
}
</style>
